<template>
  <div>
    <card class="trigger__card">
      <template #header>
        <div class="card-text">
          <div v-if="cardList.hint" class="card-icon icon-info hint-icon">
            <i v-if="cardList.icon" class="fa fa-google"/>
            <img v-if="cardList.image" :src="cardList.image" alt="">
            <el-icon v-if="cardList.iconVue" class="nc-icon">
              <component :is="cardList.iconVue"/>
            </el-icon>
          </div>
          <div class="card-text__title">
            <h4 class="card-title">
              {{ cardList.title }}
            </h4>
          </div>
          <p class="card-category">
            {{ cardList.hint }}
          </p>
        </div>
      </template>
      <div v-if="inputtedValue === undefined" class="task-options__dummy">
        <indicator/>
      </div>
      <el-switch
        v-else
        v-model="inputtedValue"
        active-text="Вкл."
        :active-value="true"
        :inactive-value="false"
        inactive-text="Откл."
        :disabled="isDisabled"/>
    </card>
  </div>
</template>

<script>
import { ElSwitch } from 'element-plus'
import Indicator from '@/components/UIComponents/Custom/Indicator'

export default {
  name: 'SwitchCard',
  components: {
    ElSwitch,
    Indicator
  },
  props: {
    type: {
      type: String,
      default: ''
    },
    actionForGetData: {
      type: Function,
      default: () => {}
    },
    actionForUpdateData: {
      type: Function,
      default: () => {}
    }
  },
  data: () => ({
    inputtedValue: undefined,
    successReq: true,
  }),
  computed: {
    cardList() {
      return this.$store.getters[`superadministrator/${this.type}`]
    },
    isDisabled() {
      return this.cardList.isDisabled
    }
  },
  watch: {
    async inputtedValue(flag, oldFlag) {
      if (oldFlag === undefined || !this.successReq) {
        this.successReq = true
        return
      }
      this.successReq = await this.actionForUpdateData({flag, type: this.type})
      if (!this.successReq) this.inputtedValue = oldFlag
    }
  },
  async beforeMount() {
    if (this.actionForGetData) await this.actionForGetData()
    this.inputtedValue = this.cardList.value
  }
}
</script>

<style scoped>

</style>
